import { LovValues, TemplateFieldsDisplayFn } from '../../../../models/template.model';
import { PACIFIC_AVAILABILITY_INDUSTRIAL_COMMON_FIELDS } from './pacific-availability.common';
import { ReportRecord } from '../../../../models/report.model';
import { getAreaSqmValues, getMediaInformation } from '../../templates-formatter.const';
import { currencyLov } from '../us/us.common';
import { map } from 'rxjs/operators';
import { displayFnWrapper, mapAndFormatDynamicValue } from '../../utils/dynamic-data-retrievers';
import { digger } from '@cbre/digger';
import { AVAILABILITY_TYPES } from '../common';
import { forkJoin } from 'rxjs';
import { concatValuesBy, defaultTxt, formatNumber } from '@miq/utils';

const measurmentsNotConsider = [
  'Canopy Area',
  'Yard Area',
  'Loading Dock Area',
  'Site Area',
  'Land Area',
  'Hardstand Area',
];

export const displayFnMap: TemplateFieldsDisplayFn = {
  ...PACIFIC_AVAILABILITY_INDUSTRIAL_COMMON_FIELDS(),
  247: { displayFn: displayFnWrapper }, // Sprinklered
  244: { displayFn: displayFnWrapper }, // Land Area
  538: {
    displayFn: (record: ReportRecord, options, suburb) => {
      const suburbVal = mapAndFormatDynamicValue(record, suburb);
      return options.isPPTHasSpecificFormat && suburbVal === defaultTxt ? ' ' : suburbVal;
    },
  }, // Subheader
  246: { displayFn: displayFnWrapper }, // Available Date
  98: {
    displayFn: (record: ReportRecord) => {
      return getMediaInformation(record);
    },
  }, // Primary Image
  99: {
    displayFn: (record: ReportRecord) => {
      return getMediaInformation(record);
    },
  }, // Additional Image
  254: {
    displayFn: (record: ReportRecord) => {
      return getMediaInformation(record);
    },
  }, // Secondary Image
  234: {
    displayFn: (record: ReportRecord, options, rentType, rent) => {
      return forkJoin([currencyLov(options), rentType.lovValues]).pipe(
        map(([currencyLOV, rentTypeLOV]) => {
          const uomArgument = { ...rent.uomArgument, isPrefix: true };
          rent = { ...rent, uomArgument };
          const rentTypeKey = mapAndFormatDynamicValue(record, rentType);
          const rentTypeVal = mapAndFormatDynamicValue(record, rent, currencyLOV, true, true);
          return getRent(rentTypeKey, rentTypeVal, rentTypeLOV);
        })
      );
    },
    isVisible: (record: ReportRecord) => {
      const availableTypeVal = digger(record, 'data.ref_availability_type_desc');
      return availableTypeVal !== AVAILABILITY_TYPES.sale;
    },
  }, // Rent ($/sqm)
  243: {
    displayFn: (record: ReportRecord, options, areaType) => {
      if (!options.isPPTHasSpecificFormat) {
        areaType = {
          ...areaType,
          field: !!areaType && !!areaType.field ? areaType.field.split('/')[1] : '',
          isRecordTableData: true,
        };
        record = record.data[0];
      }
      let areaTypeVal = mapAndFormatDynamicValue(record, areaType);
      if (Array.isArray(areaTypeVal)) {
        areaTypeVal = areaTypeVal.map(area => {
          area = !measurmentsNotConsider.some(mea => mea === area) ? `${area}*` : area;
          return area;
        });
      } else {
        areaTypeVal = measurmentsNotConsider.some(mea => mea === areaTypeVal) ? areaTypeVal : `${areaTypeVal}*`;
      }
      const result = !!areaTypeVal && options.isPPTHasSpecificFormat ? [...areaTypeVal, 'Total(NLA)*'] : areaTypeVal;
      return result;
    },
    labelDisplayFn: () => {
      return '';
    },
  }, // Area Type
  264: {
    displayFn: (record: ReportRecord, options) => {
      return getAreaSqmValues(record, options, true);
    },
  }, // Area Size
  351: {
    displayFn: (record: ReportRecord, _options) => {
      const measurements = digger(record, 'data.property_measurement_availability');
      const measurementsToConsider = measurements.filter(measurement => {
        if (!measurmentsNotConsider.some(mea => mea === measurement.property_element_type_desc)) {
          return measurement;
        }
      });
      let totalMeasurements = 0;
      measurementsToConsider.forEach(measurement => {
        totalMeasurements = totalMeasurements + measurement.property_measurement_size;
      });
      const askingRent = digger(record, 'data.asking_rental_rate_yearly');
      return formatNumber(totalMeasurements * askingRent, 'en', '0.2-2').toString();
    },
  }, // Rent ($pa)
  347: {
    displayFn: (record: ReportRecord) => {
      return getMediaInformation(record);
    },
  }, //  FloorPlan Image
  553: {
    displayFn: (record: ReportRecord, _, suite, floorNumber) => {
      const suiteVal = mapAndFormatDynamicValue(record, suite, null, null, false);
      const floorNumberVal = mapAndFormatDynamicValue(record, floorNumber, null, null, false);
      const floorPlanConst = ['Floorplan: ', 'Floor: ', ', Suite: '];
      const suitValArr: string[] = !Array.isArray(suiteVal) ? [suiteVal] : suiteVal;

      return (
        floorPlanConst[0] +
        suitValArr.map((val, i) => floorPlanConst[1] + concatValuesBy(floorPlanConst[2], floorNumberVal[i], val))
      );
    },
  }, // Floor/Suite
};

function getRent(rentTypeKey: string | string[], rentTypeVal: string | string[], rentTypeLOV: LovValues[]) {
  const lovValue = rentTypeLOV.find(a => a.key === rentTypeKey && a.key !== 'Unknown');
  return concatValuesBy(' ', rentTypeVal, rentTypeVal[0] !== defaultTxt && lovValue ? lovValue.value : '');
}
